module.exports = __webpack_public_path__ + "static/media/target-goal.1510d9e1.svg";